export default [
    {
        "consumption_id": "cb0daf8b-4961-4c68-ab79-7165e379f83e",
        "consumption_name_en": "Smoked"
    },
    {
      "consumption_id": "ba9d5407-1281-410c-b0f7-e1d224e29dd4",
      "consumption_name_en": "Vaped"
    },
    {
      "consumption_id": "7e233741-0842-486f-9ab8-8bdfe51ba604",
      "consumption_name_en": "Oral / Eating"
    },
    {
      "consumption_id": "123d7a1e-c7fc-446a-ad94-3cd989c1fa80",
      "consumption_name_en": "Topical"
    }
  ]